import slide_statistics from 'src/assets/images/slide-statistics.png';
import { commonMessages } from 'src/features/auth/utils/messages';
const USER_QUERY_KEY = 'authenticated-user';

const LANDING_SLIDES = [
    {
        image: slide_statistics,
        title: commonMessages.slideshowTitleStatistics,
        subtitle: commonMessages.slideshowSubtitleStatistics,
    },
    {
        image: slide_statistics,
        title: commonMessages.slideshowTitleStatistics,
        subtitle: commonMessages.slideshowTitleStatistics,
    },
];

export { USER_QUERY_KEY, LANDING_SLIDES };
